import { TypSablonyE, VolitelnostSkupinyE } from '@generated/be';
import { StatusLabel } from '@shared/utils';

export const volitelneUzivatelem: Record<VolitelnostSkupinyE, StatusLabel> = {
  NENI: {
    label: 'Není',
  },
  PRI_POSTOUPENI: {
    label: 'Při postoupení',
  },
  PRI_SESTAVENI: {
    label: 'Při sestavení',
  },
  PRI_SESTAVENI_A_POSTOUPENI: {
    label: 'Při sestavení a postoupení',
  },
};

export const typySablonOptions = [
  {
    id: TypSablonyE.ImplZz,
    label: 'Implicitní ze zákona',
  },
  {
    id: TypSablonyE.ImplNzra,
    label: 'Implicitní na základě rozhodnutí',
  },
  {
    id: TypSablonyE.Expl,
    label: 'Explicitní',
  },
];
